<template>
  <div class="my-4">
    <div
      class="flex flex-col md:flex-row gap-2 justify-between md:items-center mb-2"
    >
      <label class="fs-18 required"
        >{{ $t("Người nhận điểm")
        }}{{ `(${selectedDoctors && selectedDoctors.length})` }}</label
      >
      <button
        :disabled="isLoading"
        @click="handleOpenModalProducts"
        class="fs-14 flex items-center gap-1 justify-center border-0 focus:outline-none bg-indigo-50 text-blue-900 rounded-lg h-8 px-3 py-2"
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M28 16C28 16.2652 27.8946 16.5196 27.7071 16.7071C27.5196 16.8946 27.2652 17 27 17H17V27C17 27.2652 16.8946 27.5196 16.7071 27.7071C16.5196 27.8946 16.2652 28 16 28C15.7348 28 15.4804 27.8946 15.2929 27.7071C15.1054 27.5196 15 27.2652 15 27V17H5C4.73478 17 4.48043 16.8946 4.29289 16.7071C4.10536 16.5196 4 16.2652 4 16C4 15.7348 4.10536 15.4804 4.29289 15.2929C4.48043 15.1054 4.73478 15 5 15H15V5C15 4.73478 15.1054 4.48043 15.2929 4.29289C15.4804 4.10536 15.7348 4 16 4C16.2652 4 16.5196 4.10536 16.7071 4.29289C16.8946 4.48043 17 4.73478 17 5V15H27C27.2652 15 27.5196 15.1054 27.7071 15.2929C27.8946 15.4804 28 15.7348 28 16Z"
            fill="currentColor"
          />
        </svg>
        {{ $t("Thêm dòng") }}
      </button>
    </div>
    <el-table
      class="cs-table"
      :class="selectedDoctors.length && 'cs-hidden-border'"
      :data="selectedDoctors"
      border
      style="width: 100%"
    >
      <el-table-column type="index" label="STT"></el-table-column>
      <el-table-column
        prop="name"
        :label="$t('Tên nhân viên')"
      ></el-table-column>
      <el-table-column prop="email" :label="$t('Email')"></el-table-column>
      <el-table-column
        :formatter="
          (row) =>
            mdtUtils.getRoleMember(
              row && row.doctor_infor && row.doctor_infor.type
            )
        "
        :label="$t('Chức danh')"
      ></el-table-column>
    </el-table>
    <ModalSelectDoctorsWS
      ref="ModalSelectDoctorsWS"
      @onSelectedDoctors="(data) => $emit('onSelectedDoctors', data)"
      :selectedDoctorsProps="selectedDoctors"
    />
  </div>
</template>

<script>
import mdtUtils from '../../../utils/mdtUtils'
import ModalSelectDoctorsWS from './ModalSelectDoctorsWS.vue'

export default {
  name: 'SelectedDoctors',
  components: { ModalSelectDoctorsWS },
  props: {
    selectedDoctors: Array
  },
  data () {
    return {
      isLoading: false,
      mdtUtils
    }
  },
  methods: {
    handleOpenModalProducts () {
      this.$refs.ModalSelectDoctorsWS.handleOpen(this.selectedDoctors)
    }
  }
}
</script>

<style lang="scss" scoped>
.cs-table {
  height: 100%;
  max-height: 500px;
  overflow-y: scroll;
  border-bottom: 1px solid #ebeef5;

  &::before {
    height: 0;
  }
}

.cs-hidden-border {
  border-bottom: none;
}
</style>